import { Controller } from "@hotwired/stimulus";

interface StatusPayload {
  status: string;
  total: number;
  completed: number;
  created_group_ids: number[];
  error_log: string;
}

export default class extends Controller {
  static targets = ["progress", "state", "groups", "errors"];
  static values = { url: String, groupLabel: String };

  declare progressTarget: HTMLElement;
  declare stateTarget: HTMLElement;
  declare groupsTarget: HTMLElement;
  declare errorsTarget: HTMLElement;

  declare urlValue: string;
  declare groupLabelValue: string;

  private timer: ReturnType<typeof setTimeout> | null = null;

  connect(): void {
    this.poll();
  }

  disconnect(): void {
    if (this.timer !== null) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  }

  private async poll(): Promise<void> {
    const response = await fetch(this.urlValue, {
      headers: { Accept: "application/json" },
    });
    const data: StatusPayload = await response.json();

    this.progressTarget.textContent = `${data.completed} / ${data.total}`;
    this.stateTarget.textContent = data.status;
    this.errorsTarget.textContent = data.error_log;
    const label = this.groupLabelValue || "Group";
    this.groupsTarget.replaceChildren(
      ...(data.created_group_ids || []).map((id) => {
        const li = document.createElement("li");
        li.className = "mb-1";
        const a = document.createElement("a");
        a.href = `/admin/groups/${id}`;
        a.className = "btn btn-falcon-default btn-sm";
        const icon = document.createElement("i");
        icon.className = "fas fa-external-link-alt mr-1";
        a.appendChild(icon);
        a.appendChild(document.createTextNode(`${label} #${id}`));
        li.appendChild(a);
        return li;
      })
    );

    if (data.status === "completed" || data.status === "failed") return;

    this.timer = setTimeout(() => this.poll(), 2000);
  }
}
